import { Component, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Modal } from 'bootstrap';
import { ReportDiscountsService } from '../../services/report_discounts.service';
import Swal from 'sweetalert2';
import { UserService } from '../../../user/services/user.service';

@Component({
  selector: 'app-list-discounts',
  templateUrl: './list-discounts.component.html',
  styleUrl: './list-discounts.component.scss'
})
export class ListDiscountsComponent {
  @ViewChild('addUserConceptModal',{static:false}) modalElement!: ElementRef;
  modalInstance!: Modal;
  filter: any
  userRole = this.userService.getUserRole()
  discounts: any[] = []
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private reportDiscountsService: ReportDiscountsService,
    private userService: UserService
  ) {

  }

  /*     ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
          import('bootstrap').then(({ Modal }) => {
            if (this.modalElement?.nativeElement) {
              this.modalInstance = new Modal(this.modalElement.nativeElement);
            }
          });
        }
      } */

  /*   ngAfterViewInit() {
      if (isPlatformBrowser(this.platformId) && !this.modalInstance) {
        import('bootstrap').then(({ Modal }) => {
          if (this.modalElement?.nativeElement) {
            this.modalInstance = Modal.getInstance(this.modalElement.nativeElement) || new Modal(this.modalElement.nativeElement);
          }
        });
      }
    } */

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.modalElement?.nativeElement) {
      import('bootstrap').then(({ Modal }) => {
        const existingInstance = Modal.getInstance(this.modalElement.nativeElement);
        if (existingInstance) {
          this.modalInstance = existingInstance;
        } else {
          this.modalInstance = new Modal(this.modalElement.nativeElement);
        }
      });
    }
  }

  ngOnInit() {
    this.reportDiscountsService.currentFilter$.subscribe(filter => {
      if (filter) {
        this.filter = filter
        this.loadDiscounts(this.filter)
      }
    })

    this.reportDiscountsService.closeModal$.subscribe(closeModal => {
      if (closeModal == true) {
        this.closeModal()
      }

      if (closeModal == false) {
        this.openModal()
      }

    })
  }

  loadDiscounts(filter: any) {
    if (!filter || !filter.periodId || !filter.userId) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se ha seleccionado un periodo o usuario.',
        timer: 2000
      })
      this.discounts = []
      return
    }
    this.reportDiscountsService.get(filter.periodId, filter.userId).subscribe((data: any) => {
      this.discounts = data
    })
  }

  editDiscount(discount: any) {
    if (!this.isClosedPeriod()) {
      this.reportDiscountsService.setcurrentDiscount(discount)
      //timer si es necesario
      this.openModal()
    }
  }

  deleteDiscount(discount: any) {
    if (!this.isClosedPeriod()) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción eliminará el descuento permanentemente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.reportDiscountsService.delete(discount._id).subscribe({
            next: () => {
              Swal.fire('Eliminado', 'El descuento ha sido eliminado correctamente.', 'success');
              this.loadDiscounts(this.filter); // Recargar los descuentos después de eliminar
            },
            error: (error) => {
              console.error('Error al eliminar el descuento:', error);
              Swal.fire('Error', 'No se pudo eliminar el descuento.', 'error');
            }

          });
        }
      });
    } else {
      Swal.fire('Acción no permitida', 'No puedes eliminar descuentos de un período cerrado.', 'warning');
    }
  }

  isClosedPeriod(): Boolean {
    if (this.filter.isClosed == true) {
      Swal.fire({
        icon: 'error',
        title: 'No se puede editar',
        text: 'El periodo está cerrado, abra nuevamente el periodo para poder hacer cambios',
        timer: 2000
      })
      return true
    }
    return false
  }

  closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide(); // Cierra el modal
      /*       this.reportDiscountsService.setCloseModal(false)//llamada a cerrar
       */
      this.loadDiscounts(this.filter) // Recargar los descuentos después de cerrar el modal
    }
  }
  openModal() {
    if (this.modalInstance && !this.modalElement.nativeElement.classList.contains('show')) {
      this.modalInstance.show(); // Abre el modal solo si no está abierto
    }
  }
}
